import { gql } from '@apollo/client'
import { useApolloClient } from '@apollo/client/react'
import { useCallback } from 'react'

export const collaboratorsQuery = gql`
  query getCollaboratorUsers($filter: JSON!, $options: JSON) {
    getCollaboratorUsers(filter: $filter, options: $options) {
      _id
      profile {
        _id
        name
        email
        picture
      }
      status
      company {
        _id
        name
        domain
      }
    }
  }
`

export const useMentions = ({ companyIds }: { companyIds?: string[] } = { companyIds: [] }) => {
  const client = useApolloClient() // 👈 Get the Apollo Client instance

  const getOptions = useCallback(
    async (pattern: string) => {
      const { data } = await client.query({
        query: collaboratorsQuery,
        variables: {
          filter: {
            $or: [
              { 'profile.name': { $regex: pattern, $options: 'i' } },
              { 'profile.email': { $regex: pattern, $options: 'i' } },
            ],
            'company._id': { $in: companyIds },
          },
          options: { limit: 10, sort: { 'profile.nameToLower': 1 } },
        },
        fetchPolicy: 'no-cache', // optional: avoid Apollo writing to cache
      })

      const users = data?.getCollaboratorUsers || []
      return users.map((item) => ({ value: item._id, ...item }))
    },
    [client, companyIds]
  )

  return { getOptions }
}
